import { Eye, EyeOff, Loader2 } from "lucide-react";
import { Card } from "../_shared";
import { Switch } from "@/components/ui/switch";
import { MODE_META } from "./constants";

export default function CoverToggleCard({
  isCoverOn,
  siteMode,
  togglingSite,
  onToggle,
}) {
  return (
    <Card
      className="p-5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4"
      testid="admin-cover-toggle-card"
    >
      <div className="flex items-start gap-3 min-w-0">
        <span
          className={`mt-0.5 inline-flex h-9 w-9 items-center justify-center rounded-xl ${
            isCoverOn
              ? "bg-emerald-100 text-emerald-700"
              : "bg-slate-100 text-slate-500"
          }`}
          data-testid="admin-cover-toggle-icon"
        >
          {isCoverOn ? (
            <Eye className="h-4 w-4" />
          ) : (
            <EyeOff className="h-4 w-4" />
          )}
        </span>
        <div className="min-w-0">
          <div className="flex flex-wrap items-center gap-2">
            <h2
              className="text-base font-medium text-slate-900"
              data-testid="admin-cover-toggle-title"
            >
              Cover page
            </h2>
            <span
              className={`inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium ${
                isCoverOn
                  ? "bg-emerald-100 text-emerald-700"
                  : "bg-slate-200 text-slate-600"
              }`}
              data-testid="admin-cover-toggle-status"
            >
              {isCoverOn
                ? `On · showing "${MODE_META[siteMode]?.label || siteMode}"`
                : "Off · site is live"}
            </span>
          </div>
          <p className="mt-1 text-sm text-slate-500">
            {isCoverOn
              ? "Public visitors are seeing the cover splash. Admins always bypass."
              : "Flip this on to show the currently selected mode below to public visitors."}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-3 shrink-0">
        {togglingSite ? (
          <Loader2
            className="h-4 w-4 animate-spin text-slate-400"
            data-testid="admin-cover-toggle-spinner"
          />
        ) : null}
        <span className="text-xs text-slate-500">
          {isCoverOn ? "On" : "Off"}
        </span>
        <Switch
          checked={isCoverOn}
          disabled={togglingSite}
          onCheckedChange={onToggle}
          aria-label="Toggle cover page on or off"
          data-testid="admin-cover-toggle-switch"
        />
      </div>
    </Card>
  );
}
